<template>
  <roe-error-message :field="design.age_requirement_profit_sharing_months">
    <input
      type="number"
      v-model.number="design.$model.age_requirement_profit_sharing_months"
      required
      min="0"
    />
    <label class="input-label-inside">months</label>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
export default {
  name: "RoeEmployerOtherAgeRequirementMonthsInput",
  components: { RoeErrorMessage },
  props: {
    design: Object
  }
};
</script>
